const styles = (theme) => ({
  infoTitle: {
    fontSize: theme.textFontSize,
    fontWeight: 400,
    lineHeight: "16px",
    color: theme.dispatchPanelHeaderColor,
    flexShrink: 0,
  },
  infoValue: {
    fontSize: theme.textFontSize,
    fontWeight: 500,
    lineHeight: "16px",
    color: theme.TextColor,
    wordBreak: "break-word",
  },
  infoContainer: {
    border: `1px solid ${theme.AppBGColor}`,
    borderRadius: 4,
    padding: "8px 16px",
    marginTop: 12,
  },
  pickupDetailsInfoContainer: {
    display: 'flex',
    flexWrap: 'wrap',
    border: `1px solid ${theme.AppBGColor}`,
    borderRadius: 4,
    padding: "8px 16px",
    marginTop: 12,
    columnGap: '24px',
  },
  billInfoContainer: {
    display: 'flex',
    border: `1px solid ${theme.AppBGColor}`,
    borderRadius: 4,
    padding: "8px 16px",
    marginTop: 12,
  },
  statusRowContainer: {
    display: 'flex',
    alignItems: 'flex-start',
    marginBottom: 14,
    columnGap: '24px',
    flexWrap: 'wrap'
  },
  timeRowContainer: {
    display: 'flex',
    alignItems: 'center',
    marginBottom: 14,
    columnGap: '56px',
    flexWrap: 'wrap'
  },
  shipperLoadRowContainer: {
    display: 'flex',
    flexDirection: "column"
  },
  pickupDetailsColContainer: {
    display: 'flex',
    flexDirection: "row",
    width: '100%'
  },
  infoRow: {
    padding: "8px 0",
  },
  sectionTitle: {
    color: theme.palette.primary.main,
    fontSize: theme.headerTextFontSize,
    lineHeight: "19px",
    fontWeight: 600,
    marginRight : 8,
  },
  sectionInfo: {
    color: theme.TextColor,
    lineHeight: "19px",
    fontWeight: 400,
    fontSize: theme.headerTextFontSize,
  },
  rightPanelInfoSection: {
    flexDirection: "row",
    display: "flex",
    padding: "8px 0",
    width: '33%'
  },
  infoPadding: {
    padding: " 0 12px",
  },
  statusTitleContainer : {
    display : "inline-flex",
    alignItems : "center"
  },
  billingContainer: {
    marginTop: 38
  }
});

export default styles;
